/**
 * Load a script dynamically.
 *
 * @param {string} scriptUri      The location of the script
 * @param {string=} id
 * @param {boolean=} useCors
 * @return {Promise}              Will resolve after the script has loaded or reject on error.
 */
export const loadScript = (scriptUri, id, useCors = false) => new Promise((resolve, reject) => {
  // build new script and set onLoad event.
  const script = document.createElement('script');

  if (id) {
    script.id = id;
  }

  if (useCors) {
    script.crossOrigin = 'anonymous';
  }

  script.async = true;
  script.onload = () => resolve();
  script.onerror = (e) => reject(e);
  script.src = scriptUri;

  // attach to the head
  const [s] = document.getElementsByTagName('script');
  s.parentNode.insertBefore(script, s);
});

export const safeScriptLoad = async (...args) => {
  try {
    await loadScript(...args);
  } catch {
    // do nothing
  }
};
